/** Imágenes en src/assets/images/proyectos/ (origen: frontend/assets/images/) */
import kipoImg from "../assets/images/proyectos/kipo.png";
import fotografiaiaImg from "../assets/images/proyectos/fotografiaia.png";
import djangoScannerImg from "../assets/images/proyectos/djangosecurityscanner.png";
import campoconectaImg from "../assets/images/proyectos/campoconecta.png";
import almaImg from "../assets/images/proyectos/almaconexionplata2.png";
import webpagesImg from "../assets/images/proyectos/webpages.png";
import cvagenticImg from "../assets/images/proyectos/cvagentic.png";

/**
 * Apps publicadas en tiendas.
 * Los textos (nombre/descripcion/tipo) viven en i18n bajo `proyectos.items.<key>`.
 */
export const PROYECTOS = [
    {
        key: "webpages",
        url: "https://play.google.com/store/apps/details?id=com.emmpieza.tunegocioonline",
        urlWeb: "https://webpages.emmpieza.com/",
        imagen: webpagesImg,
    },
    {
        key: "cvagentic",
        urlWeb: "https://cvanalyzer.emmpieza.com/",
        imagen: cvagenticImg,
    },
    {
        key: "alma",
        url: "https://play.google.com/store/apps/details?id=com.emmpieza.almaconexionplata&hl=es_CO",
        imagen: almaImg,
    },
    {
        key: "campoconecta",
        url: "https://play.google.com/store/apps/details?id=com.emmpieza.tuappagricolamarket&hl=es_CO",
        imagen: campoconectaImg,
        casePath: "/casos/campoconecta",
    },
];

/**
 * Casos de éxito — filtros: All, AI, Web, Mobile, Cybersecurity.
 * Los textos (titulo/reto/solucion/metrica/metricaEtiqueta) viven en i18n bajo `proyectos.casos.<key>`.
 */
export const CASOS_EXITO = [
    {
        key: "kipo",
        categoria: "Web",
        categoria_tag: "WEBSITE",
        url: "https://kipo.com.co/",
        imagen: kipoImg,
    },
    {
        key: "fotografiaia",
        categoria: "AI",
        categoria_tag: "AI",
        url: "https://inteligenciaartificial.emmpieza.com/",
        imagen: fotografiaiaImg,
    },
    {
        key: "djangoscanner",
        categoria: "Cybersecurity",
        categoria_tag: "CYBERSECURITY",
        url: "https://github.com/3p1c0w3nd/extension-vs-scan-vuln-django",
        imagen: djangoScannerImg,
        casePath: "/casos/scanner-django-vsecuritycode",
    },
    {
        key: "campoconecta",
        categoria: "Mobile",
        categoria_tag: "MOBILE",
        url: "https://play.google.com/store/apps/details?id=com.emmpieza.tuappagricolamarket&hl=es_CO",
        imagen: campoconectaImg,
        casePath: "/casos/campoconecta",
    },
    {
        key: "alma",
        categoria: "Mobile",
        categoria_tag: "MOBILE",
        urlandroid:
            "https://play.google.com/store/apps/details?id=com.emmpieza.almaconexionplata&hl=es_CO",
        urlios: "https://apps.apple.com/co/app/alma-conexion-plata/id6756738715",
        imagen: almaImg,
    },
];

export const FILTROS_CASOS = ["All", "AI", "Web", "Mobile", "Cybersecurity"];
